<template>
  <div>
    <v-card class="transparent elevation-0">
      <v-container container--fluid grid-list-md>
        <v-row>
          <v-col cols="12" :class="{'text-center': $vuetify.breakpoint.smAndDown}">
            <h1>Scanners</h1>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" md="4">
            <v-text-field label="Search..." v-model="search" prepend-icon="search"></v-text-field>
          </v-col>

          <v-col cols="12" md="3">
            <v-select
              :items="renderedDepots"
              item-text="name"
              item-value="id"
              return-object
              v-model="depot"
              clearable
              prepend-icon="fas fa-map"
              label="Depot...">
            </v-select>
          </v-col>

          <v-col cols="12" md="4">
            <v-row align="center">
              <v-col cols="12" md="6">
                <v-switch v-model="allSwitch" label="Show All" color="green"></v-switch>
              </v-col>
              <v-col cols="12" md="6" class="text-center">
                <v-tooltip top color="secondary" v-if="admin">
                  <template v-slot:activator="{ on }">
                    <v-btn class="mx-2" fab dark color="blue lighten-1" @click="newScanner" v-on="on">
                      <v-icon dark>add</v-icon>
                    </v-btn>
                  </template>
                  <span>Create a new scanner</span>
                </v-tooltip>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-container>
      <v-divider></v-divider>
      <v-data-table
        :headers="headers"
        :items="renderedScanners"
        :search="search"
      >
        <template v-slot:item="props">
          <tr class="cursor" v-bind:class="{odd: props.index % 2, even: !props.index % 2}">
            <td style="text-align: center">
              <v-tooltip top color="secondary">
                <template v-slot:activator="{ on }">
                  <v-icon :color="props.item.status === 'Removed' ? 'orange' : 'green'" v-on="on">fiber_manual_record
                  </v-icon>
                </template>
                <span>
                  {{props.item.status === 'Removed' ? 'This scanner has been removed' : 'This scanner has not been removed yet'}}
                </span>
              </v-tooltip>
            </td>
            <td style="text-align: center"
                v-for="(header, index) in headers"
                v-if="header.text !== 'Actions' && header.text !== 'Status'"

                :key="index">{{props.item[header.value]}}
            </td>
            <td v-if="editPermission" style="text-align: center">
              <v-tooltip top color="secondary">
                <template v-slot:activator="{ on }">
                  <v-icon  color="blue" @click="rowSelected(props.item) " v-on="on">
                    edit
                  </v-icon>
                </template>
                <span>Edit</span>
              </v-tooltip>
              <v-tooltip top color="secondary" v-if="admin">
                <template v-slot:activator="{ on }">
                  <v-icon color="red" @click="toggleDeleteDialog(props.item)" v-on="on" class="pl-1">
                    delete
                  </v-icon>
                </template>
                <span>Delete</span>
              </v-tooltip>
            </td>
          </tr>
        </template>
      </v-data-table>
    </v-card>

    <v-dialog
      v-model="deleteDialog"
      max-width="500px"
      persistent
    >
      <v-card>
        <v-card-title>
          <h3>ATTENTION</h3>
        </v-card-title>
        <v-card-text>
          You are about to delete this scanner. This action cannot be undone. <br>
          Are you sure you want to proceed ?
        </v-card-text>
        <v-card-actions class="justify-center">
          <v-btn text color="blue-grey lighten-2" @click="toBeDeleted=null; deleteDialog=false">No</v-btn>
          <v-btn text color="blue darken-1" @click="deleteScanner">Yes</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>


      <v-dialog v-model="editDialog" v-if="displayedItem" width="800px">
        <v-card>
          <v-card-title class="d-flex" style="position: relative" :class="$vuetify.breakpoint.smAndDown ? 'justify-start' : 'justify-center'">
            <h2>{{editedIndex > -1 ? 'Edit scanner' : 'New scanner'}}</h2>
            <v-btn icon style="position: absolute; right: 15px; top: 10px;" @click="editDialog=false">
              <v-icon>close</v-icon>
            </v-btn>
          </v-card-title>
          <v-divider></v-divider>
          <v-card-text>
            <v-row justify="space-around">
              <v-list two-line>
                <v-row justify="center" align="center">
                  <v-col cols="12" sm="12" md="6" class="py-0" v-for="(key, index) in Object.keys(displayedItem)" :key="index">
                    <v-list-item v-if="key!=='cost'">
                      <v-list-item-action>
                        <div v-if="key === 'date_added'">
                          <v-icon color="green">{{icons[key]}}</v-icon>
                        </div>
                        <div v-else-if="key === 'status'">
                          <v-icon :color="displayedItem[key] === 'Removed' ? 'red' : 'green'">fiber_manual_record
                          </v-icon>
                        </div>
                        <div v-else>
                          <v-icon :color="key === 'date_removed' ? 'orange' : '#00a7d3'">{{icons[key]}}</v-icon>
                        </div>
                      </v-list-item-action>
                      <v-list-item-content class="pt-0">
                        <div v-if="!fab">
                          <v-list-item-title>{{capitalizeFirstLetter(key)}}</v-list-item-title>
                              <v-list-item-subtitle v-on="on">
                                {{displayedItem[key]}}
                              </v-list-item-subtitle>
                        </div>

                        <div v-else>
                          <v-form ref="form" v-model="valid" lazy-validation>
                            <div v-if="key === 'depot_id'">
                              <v-select
                                :items="renderedDepots"
                                item-value="id"
                                item-text="name"
                                v-model="editedItem[key]"
                                label="Depot"
                                :disabled="!admin"></v-select>
                            </div>
                            <div v-else-if="key === 'status'">
                              <v-select
                                :items="status"
                                v-model="editedItem[key]"
                                label="Status"
                                :disabled="!admin"></v-select>
                            </div>
<!--                            <div v-else-if="key!=='cost'">-->
<!--                              <v-text-field v-model="editedItem[key]"-->
<!--                                            :label="capitalizeFirstLetter(key)"-->
<!--                                            :disabled="readOnly.includes(key) || (adminEditabled.includes(key) && !admin)"-->
<!--                              ></v-text-field>-->
<!--                            </div>-->
                            <div v-else >
                              <v-text-field v-model="editedItem[key]"
                                            :label="capitalizeFirstLetter(key)"
                                            :disabled="readOnly.includes(key) || (adminEditabled.includes(key) && !admin)"
                              ></v-text-field>
                            </div>
                          </v-form>
                        </div>
                      </v-list-item-content>
                    </v-list-item>
                  </v-col>
                </v-row>
              </v-list>
            </v-row>
            <v-row justify="center" align="center" :class="{'flex-column': $vuetify.breakpoint.smAndDown}">
              <v-col md="2" cols="12" class="text-center">
                <v-btn
                  text
                  @click="editDialog=false;"
                  color="blue-grey lighten-2"
                >Cancel
                </v-btn>
              </v-col>
              <v-col md="2" cols="12" class="text-center">
                <v-btn
                  text
                  @click="saveChanges"
                  color="blue darken-1"
                >Save
                </v-btn>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-dialog>

  </div>
</template>

<script>
    import axios from 'axios'

    // @vuese
    // For further information on how this page works, have a look at ManagePhonesTable documentation.
    // @group ManageDevices
    export default {
        name: "ManageScannersTable",
        data() {
            return {
                dateAddedMenu: false,
                dateRemovedMenu: false,
                valid: false,
                fab: false,
                requiredRule: [
                    v => !!v || 'This field is required.'
                ],
                icons: {
                    id: 'card_travel',
                    depot_id: 'location_city',
                    manufacturer: 'phone_in_talk',
                    model: 'smartphone',
                    imei: 'phonelink_setup',
                    date_added: 'watch_later',
                    date_removed: 'watch_later',
                    allocated_to: 'person',
                    cost: 'attach_money',
                    mac: 'wifi',
                    notes: 'speaker_notes',
                    phone: 'phone',
                    last_used: 'watch',
                    last_used_by: 'people',
                },
                readOnly: [
                    "id",
                    "date_added",
                    "date_removed",
                    "status",
                    "mdm_id",
                    "last_used",
                    "last_used_by"
                ],
                adminEditabled: [
                    "imei",
                    "serial",
                    "depot_id",
                    "manufacturer",
                    "model",
                    "mac",
                ],
                search: null,
                toBeDeleted: null,
                deleteDialog: false,
                allSwitch: false,
                editedIndex: -1,
                editedItem: {
                    id: 0,
                    depot_id: null,
                    manufacturer: null,
                    model: null,
                    imei: null,
                    phone: null,
                    date_added: null,
                    date_removed: null,
                    status: null,
                    allocated_to: null,
                    notes: null,
                    mac:null,
                    last_used: null,
                    last_used_by: null,
                    cost: null,
                },
                defaultScanner: {
                    id: 0,
                    depot_id: 0,
                    manufacturer: null,
                    model: null,
                    imei: null,
                    phone: null,
                    date_added: null,
                    date_removed: null,
                    status: 'Pending',
                    mac:null,
                    allocated_to: null,
                    notes: null,
                    last_used: null,
                    last_used_by: null,
                    cost: null,
                },
                editDialog: false,
                displayedItem: null,
                status:[
                  "Active",
                  "Removed",
                  "Pending",
                ],
                reload: false,
                depot: null
            }
        },
        methods: {
            newScanner() {
                this.editedIndex = -1;
                this.displayedItem = Object.assign({}, this.defaultScanner);
                this.editedItem = Object.assign({}, this.defaultScanner);
                this.fab = true;
                this.editDialog = true;
            },
            capitalizeFirstLetter(string) {
                string = string.replace(/_/g, ' ');
                return string.charAt(0).toUpperCase() + string.slice(1);
            },
            updateDataTable() {
              this.reload = !this.reload;
            },
            rowSelected(item) {
                this.displayedItem = {
                  id: item['id'],
                  depot_id: item['depot_id'],
                  manufacturer: item['manufacturer'],
                  model: item['model'],
                  imei: item['imei'],
                  phone: item['phone'],
                  date_added: item['date_added'],
                  date_removed: item['date_removed'],
                  status: item['status'],
                  mac: item['mac'],
                  allocated_to: item['allocated_to'],
                  notes: item['notes'],
                  last_used: item['last_used'],
                  last_used_by: item['last_used_by']
              },
                this.editedItem = Object.assign({}, this.displayedItem);
                this.editedItem['depot_id'] = this.editedItem['depot_id'] * 1;
                this.editedIndex = this.scannersItems.indexOf(item);
                this.fab = true;
                this.editDialog = true;
            },
            toggleDeleteDialog(item) {
                this.toBeDeleted = item;
                this.deleteDialog = true;
            },
            deleteScanner() {
                let index = this.scannersItems.indexOf(this.toBeDeleted);
                axios.delete(process.env.API_URL + '/scanners/' + this.toBeDeleted.id)
                    .then((response) => {
                        this.scannersItems.splice(index, 1);
                        this.deleteDialog = false;
                        this.updateDataTable();
                    })
                    .catch((response) => {
                        this.$store.commit('displaySnackbar', 'ERROR ' + response.response.data.error);
                    })
            },
            validationInput(body){
              if (body.mac !== null) {
                if(!/^[A-Fa-f\d]{2}:[A-Fa-f\d]{2}:[A-Fa-f\d]{2}:[A-Fa-f\d]{2}:[A-Fa-f\d]{2}:[A-Fa-f\d]{2}$/.test(body.mac)){
                  this.$store.commit('displaySnackbar', 'Invalidation Mac Address');
                  return false;
                } else return true;
              } else {
                return true;
              }
            },
            saveChanges() {
                let body = this.editedItem;

                if(!this.validationInput(body)){
                  return false;
                };

                if (this.editedIndex > -1) {
                    axios.put(process.env.API_URL + '/scanners/' + body.id, body)
                        .then((response) => {
                            // this.displayedItem = Object.assign({}, response.data);
                            // Object.assign(this.scannersItems[this.editedIndex], this.displayedItem);
                            this.updateDataTable();
                            this.$store.commit('displaySnackbar', 'Changes saved.');
                        })
                        .catch((response) => {
                            this.$store.commit('displaySnackbar', 'ERROR ' + response.response.data.error);
                        })
                } else {
                    axios.post(process.env.API_URL + '/scanners', body)
                        .then((response) => {
                            // this.displayedItem = Object.assign({}, response.data);
                            // this.scannersItems.push(this.displayedItem);
                            this.updateDataTable();
                            this.$store.commit('displaySnackbar', 'Scanner created.');x
                        })
                        .catch((response) => {
                            this.$store.commit('displaySnackbar', 'ERROR ' + response.response.data.error);
                        })
                }
                this.editDialog = false;
            }
        },
        computed: {
            admin() {
                return this.$store.getters['auth/hasPermission']('device_admin');
            },
            editPermission() {
                if (this.depot == null) return false;
                if (this.depot.id === 0) return this.admin;
                return this.admin || this.$store.getters['auth/hasPermissionRegionId']('phone_edit', this.depot.region_id);
            },
            headers() {
                let headers = [
                    {text: 'Status', value: 'status', align: 'center', sortable: true},
                    {text: 'ID', value: 'id', align: 'right', sortable: true},
                    {text: 'Manufacturer', value: 'manufacturer', align: 'center', sortable: true},
                    {text: 'Model', value: 'model', align: 'center', sortable: true},
                    // {text: 'Serial', value: 'serial', align: 'center', sortable: false},
                    {text: 'IMEI', value: 'imei', align: 'center', sortable: true},
                    // {text: 'MDM ID', value: 'mdm_id', align: 'center', sortable: false},
                    {text: 'Date Added', value: 'date_added', align: 'center', sortable: true},
                    {text: 'Cost', value: 'cost', align: 'center', sortable: true},
                    {text: 'Mac', value: 'mac', align: 'center', sortable: true},
                    {text: 'Allocated To', value: 'allocated_to', align: 'center', sortable: true},
                    {text: 'Android Version', value: 'android_version', align: 'center', sortable: true},
                    {text: 'Notes', value: 'notes', align: 'center', sortable: true},
                ];
                if (this.editPermission) {
                    headers.push({text: 'Actions', value: 'actions', align: 'center', sortable: false, width: '5%'});
                }
                return headers;
            },
            renderedScanners() {
                if (this.scannersItems == null) return [];
                let output;
                output = this.scannersItems.filter((scanner) => {
                    return scanner.status === 'Active' || this.allSwitch
                });
                return output
            },
          renderedDepots() {
            if (this.depots == null) return [];
            this.depots =  this.depots.sort(function(a,b){
              if(a.name < b.name) return -1;
              if(a.name > b.name) return 1;
              return 0;
            });
            if (this.admin) {
              let gol = {
                "id": 0,
                "region_id": 0,
                "region_name": "Global",
                "name": "Global",
                "address": "",
                "address2": "",
                "suburb": "",
                "state": "NSW",
                "postcode": "",
                "code": "",
                "wms": false,
                "parent_depot": null,
                "active_phone_cap": "0"
              };
              this.depots.unshift(gol)
            }
            if (this.depots.length > 0) {
              this.depot = this.depots[0];
            }
            return this.depots;
          },
        },
        asyncComputed: {
            async scannersItems() {
              if (this.reload || !this.reload) {
                if (this.depot == null) {
                  return [];
                } else {
                  return await axios.get(process.env.API_URL + '/scanners/depots/' + this.depot.id)
                    .then((response) => {
                      return response.data;
                    })
                    .catch((response) => {
                      this.$store.commit('displaySnackbar', 'ERROR ' + response.response.data.error);
                      return [];
                    })
                }
              }
            },
            async depots() {
              return await axios.get(process.env.API_URL +'/depots')
                .then((response) => {
                  if (response.status === 200) {
                    return response.data;
                  } else {
                    return [];
                  }
                })
                .catch((error) => {
                  return [];
                });

            },
        }
    }
</script>

<style scoped>

  .v-input--selection-controls {
    justify-content: center;
  }

</style>



// WEBPACK FOOTER //
// src/components/util/ManageDevices/ManageScannersTable.vue